import React, { createContext, useContext, useState, useCallback } from 'react';
import useCallDataApi from '../hooks/data';
import { useSnackbar } from 'notistack';
const TFAContext = createContext();

export const TFAProvider = ({ children }) => {
    const [tfaEnabled, setTfaEnabled] = useState(false);
    const [qrCode, setQrCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { getData, postData } = useCallDataApi('');

    const setupTFA = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await getData('tfa/setup');
            setQrCode(response.qr_code);
            return response;
        } catch (error) {
            enqueueSnackbar('Hiba történt a TFA beállítása során', { variant: 'error' });
            throw error;
        } finally {
            setIsLoading(false);
        }
    }, [getData, enqueueSnackbar]);

    const enableTFA = useCallback(async (code) => {
        try {
            setIsLoading(true);
            console.log(code);
            const response = await postData('tfa/enable', { token: code });
            setTfaEnabled(true);
            enqueueSnackbar('TFA sikeresen engedélyezve', { variant: 'success' });
            return response;
        } catch (error) {
            enqueueSnackbar('Hiba történt a TFA engedélyezése során', { variant: 'error' });
            throw error;
        } finally {
            setIsLoading(false);
        }
    }, [postData, enqueueSnackbar]);

    const verifyTFA = useCallback(async (code) => {
        try {
            setIsLoading(true);
            const response = await postData('tfa/verify', { code });
            return response;
        } catch (error) {
            enqueueSnackbar('Hiba történt a TFA ellenőrzése során', { variant: 'error' });
            throw error;
        } finally {
            setIsLoading(false);
        }
    }, [postData, enqueueSnackbar]);

    // const verifyLoginTFA = useCallback(async (code, token) => {
    //     try {
    //         setIsLoading(true);
    //         const response = await fetch(`${baseUrl}api/token/verify_tfa/`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify({ code, token })
    //         });
    //
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }
    //
    //         const data = await response.json();
    //         return data;
    //     } catch (error) {
    //         enqueueSnackbar('Hiba történt a TFA ellenőrzése során', { variant: 'error' });
    //         throw error;
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }, [enqueueSnackbar]);

    const value = {
        tfaEnabled,
        setTfaEnabled,
        qrCode,
        isLoading,
        setupTFA,
        enableTFA,
        verifyTFA,
        // verifyLoginTFA
    };

    return (
        <TFAContext.Provider value={value}>
            {children}
        </TFAContext.Provider>
    );
};

export const useTFA = () => {
    const context = useContext(TFAContext);
    if (!context) {
        throw new Error('useTFA must be used within a TFAProvider');
    }
    return context;
}; 